import { mapGetters, mapState, mapActions } from 'vuex';
import closeButton from '@/components/generics/close-button/close-button.vue';
import purchaseJourneySushi from '@/components/purchase/sushi/purchase-journey-sushi/purchase-journey-sushi.vue';

export default {
  props: {
    market: {},
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true,
    },
    showRelatedContracts: {
      type: Boolean,
      default: false,
    },
    showContractCharts: {
      type: Boolean,
      default: false,
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false,
    },
    showOrderSlip: {
      type: Boolean,
      default: true,
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false,
    },
    layoutKind: {
      type: String,
      default: '',
    },
  },
  components: {
    closeButton,
    purchaseJourneySushi,
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'clearOrderBook']),
    ...mapActions('onboarding', ['showOnboardingStep']),
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', ['tradeOptions']),
    classModifiers() {
      return {
        'purchase-inline-sushi': true,
        'purchase-inline-sushi--with-orderslip': this.showOrderSlip,
        [`purchase-inline-sushi--${this.kind}`]: this.kind,
      };
    },
  },
  beforeDestroy() {
    this.clearOrderBook();
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-inline-sushi/purchase-inline-sushi.js